import React, { useContext, useEffect, useState } from "react";
import { AiOutlineDashboard } from "react-icons/ai";
import { BiTachometer } from "react-icons/bi";
import TraveledCard from "../../Components/TravelCard/TravelCard";
import TaskTable from "../../Components/TaskTable/TaskTable";
import RecentActivities from "../../Components/RecentActivities/RecentActivities";
import TopSale from "../../Components/TopSale/TopSale";
import PipelineOverview from "../../Components/PipelineOverview/PipelineOverview";
import { FaSearch, FaBuilding, FaSyncAlt, FaWallet, FaChevronRight } from "react-icons/fa";
import DashboardGraph from "../../Components/DashboardGraph/DashboardGraph";
import { IoNotificationsOutline, IoSend } from "react-icons/io5";
import DropDownComponent from "../../Components/DropDown/DropDown";
import { FiSearch } from "react-icons/fi";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { CiWallet } from "react-icons/ci";
import img1 from "../../images/clockdash.png";
import img2 from "../../images/phoneClock.png";
import img3 from "../../images/clockpip.png";
import img4 from "../../images/walletdash.png";
import img5 from "../../images/buildpipe.png";
import { useNavigate } from "react-router-dom";
import { TabContext } from "../../../App";
import { useDispatch, useSelector } from "react-redux";
import {
  ACTIVETAB,
  getAdminbyid,
  getBillInfo,
  getClientRecentActivites,
  getClientbyid,
  getEmployees,
  getNotificationCount,
  getPipelineOverview,
  getSales,
  getTask,
  getTopSales,
  getadminstats,
  getstats,
  sendRemider,
} from "../../Actions/actions";
import moment from "moment";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import Loader from "../../Components/Loader/Loader";
import { IoIosNotifications, IoIosNotificationsOutline } from "react-icons/io";

const DashboardScreen = () => {
  const {
    loginData,
    role,
    taskData,
    stats,
    pipelineoverview,
    recentActivites,
    notificationCount,
    subLoader,
    topsale,
    singleClient,
    singleAdmin,
    sale,
    bill,
    Privilages,
  } = useSelector((state) => state.userReducer);
  console.log(loginData, "admin");
  const dispatch = useDispatch();
  const [currentIndex, setCurrentIndex] = useState(null);
  const isRestricted = Privilages?.some(
    (priv) => priv.feature === "Notifications" && priv.accessLevel === "Restricted"
  );
  const isDashboardRestricted = Privilages?.some(
    (priv) => priv.feature === "Dashboard" && priv.accessLevel === "Restricted"
  );
  useEffect(() => {
    if (role !== "Admin") {
      dispatch(getstats(loginData?.accessToken, loginData?.clientData?.id));
      dispatch(getTopSales(loginData?.accessToken, loginData?.clientData?.id));
      dispatch(getPipelineOverview(loginData?.accessToken));
      dispatch(
        getClientbyid(
          loginData?.accessToken,
          loginData?.clientData?.id,
          () => {},
          () => {}
        )
      );
      dispatch(getEmployees(loginData?.accessToken));
      dispatch(getNotificationCount(loginData?.accessToken));
      dispatch(getTask(loginData?.accessToken));
      dispatch(getClientRecentActivites(loginData?.accessToken, loginData?.clientData?.id));
    } else {
      dispatch(getAdminbyid(loginData?.accessToken, loginData?.userId, () => {}));
      dispatch(getadminstats(loginData?.accessToken));
      dispatch(getSales(loginData?.accessToken));
      dispatch(getBillInfo(loginData?.accessToken));
    }
  }, []);
  useEffect(() => {
    document.title = "Repotal";
  }, []);

  console.log(loginData?.clientData, "newnn");

  const topSales = [
    {
      name: "John Doe",
      imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s", // Placeholder image
      target: 7,
      achieved: 3,
      percentage: 42.85,
      revenue: "AED 50,000",
    },
    {
      name: "John Doe",
      imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s", // Placeholder image
      target: 4,
      achieved: 1,
      percentage: 25,
      revenue: "AED 50,000",
    },
    {
      name: "John Doe",
      imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s", // Placeholder image
      target: 6,
      achieved: 3,
      percentage: 80,
      revenue: "AED 50,000",
    },
    {
      name: "John Doe",
      imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s", // Placeholder image
      target: 6,
      achieved: 3,
      percentage: 59,
      revenue: "AED 50,000",
    },
  ];

  const pipelineStages = [
    { stage: "Qualification", leads: 35, percentage: 25 },
    { stage: "Proposal", leads: 22, percentage: 40 },
    { stage: "Negotiation", leads: 12, percentage: 65 },
    { stage: "Won (Closed)", leads: 32, percentage: 95 },
    { stage: "Lost", leads: 11, percentage: 10 },
  ];

  const salesOverview = [
    { stage: "Total Paid Amount", leads: 37406, percentage: 60 },
    { stage: "Total Pending", leads: 1569, percentage: 23 },
    { stage: "Total Overdue", leads: 1721, percentage: 12 },
  ];
  const [travelcardAdmin, settravelcardAdmin] = useState([]);
  const [travelcard, settravelcard] = useState([]);
  useEffect(() => {
    if (role == "Admin") {
      let localdata = [
        {
          label: "Total Clients",
          value: stats?.totalClients,
          icon: <img src={img5} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
        },
        {
          label: "Active Subscriptions",
          value: stats?.activeSubscriptions,
          icon: <img src={img3} className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
        },
        {
          label: "Last Month Payment",
          value: "AED " + stats?.lastMonthPayment / 100,
          icon: <img src={img4} className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
        },
      ];
      settravelcardAdmin([...localdata]);
    } else {
      let localdata = [
        {
          label: "Total Traveled",
          value: stats.totalTravelDistance + " kms",
          icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 w-10 h-10" />,
        },
        // {
        //   label: "Total Call Time",
        //   value: stats.totalCallTime + " mins",
        //   icon: <img src={img2} className="xl:w-12 xl:h-12 w-10 h-10" />,
        // },
        {
          label: "Leads in Pipeline",
          value: stats?.leadsInPipeline,
          icon: <img src={img3} className="xl:w-12 xl:h-12 w-10 h-10" />,
        },
        {
          label: "Closed Deals",
          value: stats?.closedDeals,
          icon: <img src={img4} className="xl:w-12 xl:h-12 w-10 h-10" />,
        },
      ];
      settravelcard([...localdata]);
    }
  }, [stats]);

  const graphData = [
    { month: "Jan", task: 2000, report: 1000 },
    { month: "Feb", task: 2500, report: 1500 },
    { month: "Mar", task: 1800, report: 1400 },
    { month: "Apr", task: 2000, report: 1700 },
    { month: "May", task: 2200, report: 1900 },
    { month: "Jun", task: 2600, report: 2100 },
    { month: "Jul", task: 2800, report: 2300 },
    { month: "Aug", task: 3000, report: 2500 },
    { month: "Sep", task: 2700, report: 2300 },
    { month: "Oct", task: 3500, report: 2200 },
    { month: "Nov", task: 3200, report: 2000 },
    { month: "Dec", task: 2800, report: 1800 },
  ];

  const [selectedStatus, setSelectedStatus] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const billingStatus = [
    { value: "All", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "paid", label: "Paid" },
    { value: "overdue", label: "Over Due" },
  ];
  const filteredBills = bill?.filter((item) => {
    return (
      item.clientName.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedStatus === "All" || item.status.toLowerCase() === selectedStatus.toLowerCase())
    );
  });
  const navigate = useNavigate();
  // if (!isDashboardRestricted)
  //   return (
  //     <div className="grid place-items-center min-h-screen">
  //       <div>
  //         <h2 className="font-bold text-xl text-center">Limited Access</h2>
  //         <p className="px-4">
  //           Some information on this dashboard isn’t available for your role. You can continue using the rest of the
  //           application as usual.
  //         </p>
  //       </div>
  //     </div>
  //   );
  return (
    <ParentComponent>
      {role === "Admin" ? (
        <div>
          <div className="sm:hidden md:block">
            <div className="flex justify-between items-center mb-10 ">
              <div className="flex items-center">{/* <FiSearch className="text-gray-400 w-5 h-5" /> */}</div>
              <div className="flex gap-2 items-center flex-row">
                {isRestricted ? null : (
                  <div className="relative cursor-pointer">
                    <IoNotificationsOutline
                      onClick={() => {
                        dispatch({
                          type: ACTIVETAB,
                          payload: "Notifications",
                        });
                        navigate("/notifications");
                      }}
                      size={25}
                      className="text-gray-700"
                    />
                    {notificationCount?.count > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                        {notificationCount.count}
                      </span>
                    )}
                  </div>
                )}
                <p className="font-medium text-sm text-gray-800">
                  {role === "Admin" ? "Admin" : singleClient?.businessName}
                </p>

                {singleAdmin?.logo || singleClient?.logo ? (
                  <img
                    onClick={() => {
                      dispatch({
                        type: ACTIVETAB,
                        payload: "Settings",
                      });
                      navigate("/settings");
                    }}
                    src={
                      role === "Admin"
                        ? singleAdmin?.logo || topSales[0]?.imgSrc
                        : singleClient?.logo || topSales[0]?.imgSrc
                    }
                    className="w-10 h-10 rounded-full cursor-pointer"
                    alt="User"
                  />
                ) : (
                  <p className="font-bold text-gray-400 text-lg w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                    {role === "Admin" ? singleAdmin?.firstname?.slice(0, 1) : singleClient?.businessName?.slice(0, 1)}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-4 mb-6">
            {travelcardAdmin?.map((metric, idx) => {
              return <TraveledCard metric={metric} idx={idx} userdetails />;
            })}
          </div>

          <DashboardGraph data={graphData} />

          <div className="grid grid-cols-1 lg:grid-cols-[68%,30%] my-6 lg:justify-between">
            <div className="rounded-lg shadow-md bg-white relative">
              <div className="p-4 flex justify-between items-center">
                <h2 className="text-lg font-semibold">Bill Status</h2>
                <div className="w-full md:w-2/6 flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                  <DropDownCustom
                    isAligned={true}
                    selectedValue={billingStatus?.find((option) => option.value === selectedStatus)}
                    handleChanges={(selectedOption) => setSelectedStatus(selectedOption.value)}
                    options={billingStatus}
                    isSearchable={false}
                    label={"Status"}
                    placeholder="Select Status"
                  />
                </div>
              </div>

              <div className="overflow-x-auto min-w-full">
                <table className="min-w-full text-left">
                  <thead className="bg-[#361D3214] text-left">
                    <tr className="text-gray-500 text-sm">
                      <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[120px]">Client Name</th>
                      <th className="py-4 text-center text-gray-500 font-semibold text-sm min-w-[120px]">Status</th>
                      <th className="py-4 text-center text-gray-500 font-semibold text-sm min-w-[150px]">
                        Total Amount Due
                      </th>
                      <th className="py-4 text-gray-500 text-center font-semibold text-sm min-w-[100px]">Due Date</th>
                      <th className="py-4 text-gray-500 text-center font-semibold text-sm min-w-[150px]">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBills?.length > 0 ? (
                      filteredBills?.slice(0, 3)?.map((task, index) => (
                        <tr key={index} className="border-b">
                          <td className="pl-4 py-4 min-w-[120px]">
                            <span className="text-sm">{task.clientName}</span>
                          </td>
                          <td className="py-4 min-w-[120px] text-center">
                            <span
                              className={`text-xs px-3 py-1  font-semibold rounded ${
                                task.status === "pending"
                                  ? "bg-yellow-200 text-yellow-800"
                                  : "bg-green-200 text-green-700"
                              }`}
                            >
                              {task.status == "pending" ? "Pending" : "Paid"}
                            </span>
                          </td>
                          <td className="py-4 text-center min-w-[150px]">
                            <span className="text-sm  text-gray-700 px-3">AED {task.totalAmountDue}</span>
                          </td>

                          <td className="text-sm text-center py-4 min-w-[100px]">
                            {moment(task.subscriptionExpiryDate).format("DD-MMM-yy")}
                          </td>

                          <td className="py-4 min-w-[150px] justify-center flex  ">
                            {task.status !== "paid" &&
                              (subLoader && index == currentIndex ? (
                                <div className="flex ">
                                  <div className="justify-self-center">
                                    <div className="w-7 h-7 border-4 border-t-4 border-gray-200 border-t-primary rounded-full animate-spin"></div>
                                  </div>
                                </div>
                              ) : (
                                <button
                                  className="flex items-center text-gray-700 px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
                                  onClick={() => {
                                    setCurrentIndex(index);
                                    dispatch(sendRemider(task.clientId, loginData?.accessToken));
                                  }}
                                >
                                  <IoSend className="w-3 h-3 mr-1 text-black" />
                                  <span className="text-xs">Send Reminder</span>
                                </button>
                              ))}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4 text-gray-500">
                          No bill found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {filteredBills?.length > 3 ? (
                <div
                  className="p-4 py-6 flex justify-end"
                  onClick={() => {
                    navigate("/bill-status");
                  }}
                >
                  <a href="#" className="text-sm text-black flex items-center">
                    View All <FaChevronRight className="ml-1" />
                  </a>
                </div>
              ) : null}
            </div>
            <PipelineOverview heading="Sales Overview" pipelineStages={sale} customStyle={"sm:mt-8 md:mt-0 lg:mt-0"} />
          </div>
        </div>
      ) : isDashboardRestricted ? (
        <>
          <div className="sm:hidden md:block">
            <div className="flex justify-between items-center mb-10 ">
              <div className="flex items-center">{/* <FiSearch className="text-gray-400 w-5 h-5" /> */}</div>
              <div className="flex gap-2 items-center flex-row">
                {isRestricted ? null : (
                  <div className="relative cursor-pointer">
                    <IoNotificationsOutline
                      onClick={() => {
                        dispatch({
                          type: ACTIVETAB,
                          payload: "Notifications",
                        });
                        navigate("/notifications");
                      }}
                      size={25}
                      className="text-gray-700"
                    />
                    {notificationCount?.count > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                        {notificationCount.count}
                      </span>
                    )}
                  </div>
                )}
                <p className="font-medium text-sm text-gray-800">
                  {role === "Admin" ? "Admin" : singleClient?.businessName}
                </p>

                {singleAdmin?.logo || singleClient?.logo ? (
                  <img
                    onClick={() => {
                      dispatch({
                        type: ACTIVETAB,
                        payload: "Settings",
                      });
                      navigate("/settings");
                    }}
                    src={
                      role === "Admin"
                        ? singleAdmin?.logo || topSales[0].imgSrc
                        : singleClient?.logo || topSales[0].imgSrc
                    }
                    className="w-10 h-10 rounded-full cursor-pointer"
                    alt="Profile"
                  />
                ) : (
                  <button
                    onClick={() => navigate("/settings")}
                    className="font-bold text-gray-400 text-lg w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer"
                  >
                    {role === "Admin" ? singleAdmin?.firstname?.slice(0, 1) : singleClient?.businessName?.slice(0, 1)}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="grid place-items-center min-h-screen md:min-h-[78vh]">
            <div>
              <h2 className="font-bold text-xl text-center">Limited Access</h2>
              <p className="px-4">
                Some information on this dashboard isn’t available for your role. You can continue using the rest of the
                application as usual.
              </p>
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className="sm:hidden md:block">
            <div className="flex justify-between items-center mb-10 ">
              <div className="flex items-center">{/* <FiSearch className="text-gray-400 w-5 h-5" /> */}</div>
              <div className="flex gap-2 items-center flex-row">
                {isRestricted ? null : (
                  <div className="relative">
                    <IoNotificationsOutline
                      onClick={() => {
                        dispatch({
                          type: ACTIVETAB,
                          payload: "Notifications",
                        });
                        navigate("/notifications");
                      }}
                      size={25}
                      className="text-gray-700"
                    />
                    {notificationCount?.count > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                        {notificationCount.count}
                      </span>
                    )}
                  </div>
                )}
                <p className="font-medium text-sm text-gray-800">
                  {role === "Admin" ? "Admin" : singleClient?.businessName}
                </p>

                {singleAdmin?.logo || singleClient?.logo ? (
                  <img
                    onClick={() => {
                      dispatch({
                        type: ACTIVETAB,
                        payload: "Settings",
                      });
                      navigate("/settings");
                    }}
                    src={
                      role === "Admin"
                        ? singleAdmin?.logo || topSales[0].imgSrc
                        : singleClient?.logo || topSales[0].imgSrc
                    }
                    className="w-10 h-10 rounded-full cursor-pointer"
                    alt="Profile"
                  />
                ) : (
                  <p className="font-bold text-gray-400 text-lg w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                    {role === "Admin" ? singleAdmin?.firstname?.slice(0, 1) : singleClient?.businessName?.slice(0, 1)}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-4 mb-6">
            {travelcard?.map((metric, idx) => {
              return <TraveledCard metric={metric} idx={idx} />;
            })}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-[60%,40%] gap-4 mb-6">
            <TaskTable tasks={taskData} need />
            <RecentActivities recentActivities={recentActivites.length > 0 ? recentActivites : []} />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-[60%,40%] gap-4 sm:mb-20 md:mb-6">
            <TopSale topSales={topsale} />
            <PipelineOverview
              pipelineStages={pipelineoverview.length > 0 ? pipelineoverview : []}
              heading="Pipeline Overview"
            />
          </div>
        </div>
      )}
    </ParentComponent>
  );
};

export default DashboardScreen;
